var _style, _style2, _g, _span, _span2, _span3, _span4, _span5, _span6, _span7, _span8, _span9, _span10, _span11, _span12, _rect, _p, _rect2, _p2, _rect3, _p3, _rect4, _p4, _rect5, _p5, _rect6, _p6, _rect7, _p7, _rect8, _p8, _rect9, _p9, _defs, _defs2, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase8LangraphFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-roledescription": "flowchart-v2",
    role: "graphics-document document",
    viewBox: "0 0 1384.96875 387",
    style: {
      maxWidth: "1384.97px",
      background: "rgb(39, 23, 58)"
    },
    className: "flowchart",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    id: "export-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css\"); p {margin: 0;}")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "#export-svg{font-family:arial,sans-serif;font-size:14px;fill:#ccc;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#export-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#export-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#export-svg .error-icon{fill:#a44141;}#export-svg .error-text{fill:#ddd;stroke:#ddd;}#export-svg .edge-thickness-normal{stroke-width:1px;}#export-svg .edge-thickness-thick{stroke-width:3.5px;}#export-svg .edge-pattern-solid{stroke-dasharray:0;}#export-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#export-svg .edge-pattern-dashed{stroke-dasharray:3;}#export-svg .edge-pattern-dotted{stroke-dasharray:2;}#export-svg .marker{fill:lightgrey;stroke:lightgrey;}#export-svg .marker.cross{stroke:lightgrey;}#export-svg svg{font-family:arial,sans-serif;font-size:14px;}#export-svg p{margin:0;}#export-svg .label{font-family:arial,sans-serif;color:#ccc;}#export-svg .cluster-label text{fill:#F9FFFE;}#export-svg .cluster-label span{color:#F9FFFE;}#export-svg .cluster-label span p{background-color:transparent;}#export-svg .label text,#export-svg span{fill:#ccc;color:#ccc;}#export-svg .node rect,#export-svg .node circle,#export-svg .node ellipse,#export-svg .node polygon,#export-svg .node path{fill:#1f2020;stroke:#ccc;stroke-width:1px;}#export-svg .rough-node .label text,#export-svg .node .label text,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-anchor:middle;}#export-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#export-svg .rough-node .label,#export-svg .node .label,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-align:center;}#export-svg .node.clickable{cursor:pointer;}#export-svg .root .anchor path{fill:lightgrey!important;stroke-width:0;stroke:lightgrey;}#export-svg .arrowheadPath{fill:lightgrey;}#export-svg .edgePath .path{stroke:lightgrey;stroke-width:1px;}#export-svg .flowchart-link{stroke:lightgrey;fill:none;}#export-svg .edgeLabel{background-color:hsl(0, 0%, 34.4117647059%);text-align:center;}#export-svg .edgeLabel p{background-color:hsl(0, 0%, 34.4117647059%);}#export-svg .edgeLabel rect{opacity:0.5;background-color:hsl(0, 0%, 34.4117647059%);fill:hsl(0, 0%, 34.4117647059%);}#export-svg .labelBkg{background-color:rgba(87.75, 87.75, 87.75, 0.5);}#export-svg .cluster rect{fill:hsl(180, 1.5873015873%, 28.3529411765%);stroke:rgba(255, 255, 255, 0.25);stroke-width:1px;}#export-svg .cluster text{fill:#F9FFFE;}#export-svg .cluster span{color:#F9FFFE;}#export-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(20, 1.5873015873%, 12.3529411765%);border:1px solid rgba(255, 255, 255, 0.25);border-radius:2px;pointer-events:none;z-index:100;}#export-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#ccc;}#export-svg rect.text{fill:none;stroke-width:0;}#export-svg .icon-shape,#export-svg .image-shape{background-color:hsl(0, 0%, 34.4117647059%);text-align:center;}#export-svg .icon-shape p,#export-svg .image-shape p{background-color:hsl(0, 0%, 34.4117647059%);padding:2px;}#export-svg .icon-shape rect,#export-svg .image-shape rect{opacity:0.5;background-color:hsl(0, 0%, 34.4117647059%);fill:hsl(0, 0%, 34.4117647059%);}#export-svg .node .neo-node{stroke:#ccc;}#export-svg [data-look=\"neo\"].node rect,#export-svg [data-look=\"neo\"].cluster rect,#export-svg [data-look=\"neo\"].node polygon{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#export-svg [data-look=\"neo\"].node path{stroke:url(#export-svg-gradient);}#export-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#export-svg [data-look=\"neo\"].node .neo-line path{stroke:#ccc;filter:none;}#export-svg [data-look=\"neo\"].node circle{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#export-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#export-svg [data-look=\"neo\"].statediagram-cluster rect{fill:#1f2020;stroke:url(#export-svg-gradient);stroke-width:1px;}#export-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#export-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#export-svg :root{--mermaid-font-family:\"trebuchet ms\",verdana,arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 7.75,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 4,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 11.5,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 1,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart-margin"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 10.75,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 0,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 12.25,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: -2,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6MTAxLjU3ODEyNSwieSI6MTY2LjV9LHsieCI6MTI2LjU3ODEyNSwieSI6MTY2LjV9LHsieCI6MTUyLjA3ODEyNSwieSI6MTY3fV0=",
    "data-id": "L_START_InputParserNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-fast",
    id: "L_START_InputParserNode_0",
    d: "M101.578125,166.5L115.82567425514316,166.5Q126.578125,166.5 137.32850935668654,166.7107918501311L148.0788937133731,166.9215837002622"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    markerStart: "url(#export-svg_flowchart-v2-pointStart)",
    "data-points": "W3sieCI6MjkwLjk1ODA2NTI1NzM1MjksInkiOjEyMS41fSx7IngiOjM5Ny43ODEyNSwieSI6MzAuNX0seyJ4Ijo1MDMuMzEyNSwieSI6MzAuNX1d",
    "data-id": "L_InputParserNode_ToolExecutorNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-fast",
    id: "L_InputParserNode_ToolExecutorNode_0",
    d: "M294.0030033919923,118.90609334088161L386.76540725546687,39.88412098616554Q397.78125,30.5 412.25227339350175,30.5L499.3125,30.5"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6MzIxLjkyMTg3NSwieSI6MTY3fSx7IngiOjM5Ny43ODEyNSwieSI6MTY2LjV9LHsieCI6NDg1LjQwNjI1LCJ5IjoxNjYuNX1d",
    "data-id": "L_InputParserNode_AggregateNutritionNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_InputParserNode_AggregateNutritionNode_0",
    d: "M321.921875,167L359.8515625,166.75Q397.78125,166.5 435.711761383946,166.5L481.40625,166.5"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6MzAwLjUzNjIwMTgzNzQ1MTEsInkiOjIwNC40MjQ5MjgwMzQ0NjA2M30seyJ4IjozOTcuNzgxMjUsInkiOjI2MS41fSx7IngiOjQ4Ni41NzgxMjUsInkiOjI2MS41fV0=",
    "data-id": "L_InputParserNode_ReviewDashboardNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_InputParserNode_ReviewDashboardNode_0",
    d: "M300.5362018374511,204.42492803446063L381.33957908642765,251.85005310442884Q397.78125,261.5 416.8456151223311,261.5L482.578125,261.5"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6Mjc1LjYyMjYxNTEzMTU3ODksInkiOjIxMi41fSx7IngiOjM5Ny43ODEyNSwieSI6MzU2LjV9LHsieCI6NDc0LjE0MDYyNSwieSI6MzU2LjV9XQ==",
    "data-id": "L_InputParserNode_ProcessCustomizationNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_InputParserNode_ProcessCustomizationNode_0",
    d: "M275.6226151315789,212.5L390.08319348288506,347.4255687110571Q397.78125,356.5 409.68105576977797,356.5L470.140625,356.5"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6MzA1LjQzNDE3Njc1NTQ4MTcsInkiOjEzOC4xNDY1MjgwNzIwOTI5Nn0seyJ4IjozOTcuNzgxMjUsInkiOjk4LjV9LHsieCI6NTc2LjUxNTYyNSwieSI6OTguNX0seyJ4Ijo3MDMuODkwNjI1LCJ5Ijo5OC41fSx7IngiOjc4Ni41Njg2NTUzMDMwMzAzLCJ5IjoxNjl9XQ==",
    "data-id": "L_InputParserNode_ResponseFormatterNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-fast",
    id: "L_InputParserNode_ResponseFormatterNode_0",
    d: "M305.4341767554817,138.14652807209296L374.9658210369393,108.29514036644926Q397.78125,98.5 422.61043793611486,98.5L576.515625,98.5L689.4290469921534,98.5Q703.890625,98.5 714.8947656539927,107.88328977193906L783.5249651474961,166.40462907523707"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6NjY3LjYyNSwieSI6MTY2LjV9LHsieCI6NzAzLjg5MDYyNSwieSI6MTY2LjV9LHsieCI6NzQ3LjgzNjU2OTA5MjM5MjksInkiOjE4Mi4yMTk1OTc4MzgzMTIzNX1d",
    "data-id": "L_AggregateNutritionNode_ResponseFormatterNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_AggregateNutritionNode_ResponseFormatterNode_0",
    d: "M667.625,166.5L685.7578125,166.5Q703.890625,166.5 720.9640230021324,172.60720638434125L744.0702701793848,180.87238126408454"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6NjY2LjQ1MzEyNSwieSI6MjYxLjV9LHsieCI6NzAzLjg5MDYyNSwieSI6MjYxLjV9LHsieCI6NzQ3LjgzNjU2OTA5MjM5MjksInkiOjI0Ni43ODA0MDIxNjE2ODc2NX1d",
    "data-id": "L_ReviewDashboardNode_ResponseFormatterNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_ReviewDashboardNode_ResponseFormatterNode_0",
    d: "M666.453125,261.5L685.171875,261.5Q703.890625,261.5 721.6401748740544,255.55482709831293L744.0436769657168,248.05082308224848"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6Njc4Ljg5MDYyNSwieSI6MzU2LjV9LHsieCI6NzAzLjg5MDYyNSwieSI6MzU2LjV9LHsieCI6Nzk2LjY4OTUyODUwODc3MTksInkiOjI2MH1d",
    "data-id": "L_ProcessCustomizationNode_ResponseFormatterNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_ProcessCustomizationNode_ResponseFormatterNode_0",
    d: "M678.890625,356.5L691.390625,356.5Q703.890625,356.5 712.5549905168119,347.4900737965797L793.916931543392,262.8831763850945"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6OTQwLjcyMDc4MzE4OTUyNDcsInkiOjE5Ny4yNDk2NTE4MzE2NjgyfSx7IngiOjEwMDcuMzc1LCJ5IjoxODUuMjV9LHsieCI6MTA2NC42NzE4NzUsInkiOjE4NS4yNX1d",
    "data-id": "L_ResponseFormatterNode_VisualizeNutritionNode_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_ResponseFormatterNode_VisualizeNutritionNode_0",
    d: "M940.7207831895247,197.2496518316682L981.1481820644339,189.97157200157642Q1007.375,185.25 1034.0234375,185.25L1060.671875,185.25"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6MTIzOC4wNDY4NzUsInkiOjE4NS4yNX0seyJ4IjoxMjYzLjA0Njg3NSwieSI6MTg1LjI1fSx7IngiOjEyOTEuNDI2NzM0MTc5NDMzNCwieSI6MTk2Ljk5NjQ3MTkxMzIwNjA4fV0=",
    "data-id": "L_VisualizeNutritionNode_END_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-slow",
    id: "L_VisualizeNutritionNode_END_0",
    d: "M1238.046875,185.25L1250.546875,185.25Q1263.046875,185.25 1274.5966422312258,190.0304682725128L1287.7308086654411,195.46672206600198"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd)",
    "data-points": "W3sieCI6OTQwLjcyMDc4MzE4OTUyNDcsInkiOjIzMS43NTAzNDgxNjgzMzE4fSx7IngiOjEwMDcuMzc1LCJ5IjoyNDIuNzV9LHsieCI6MTE1MS4zNTkzNzUsInkiOjI0Mi43NX0seyJ4IjoxMjYzLjA0Njg3NSwieSI6MjQyLjc1fSx7IngiOjEyOTEuNDI2NzM0MTc5NDMzNCwieSI6MjMxLjAwMzUyODA4Njc5MzkyfV0=",
    "data-id": "L_ResponseFormatterNode_END_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link edge-animation-fast",
    id: "L_ResponseFormatterNode_END_0",
    d: "M940.7207831895247,231.7503481683318L974.0478915947624,237.2501740841659Q1007.375,242.75 1041.1528661220473,242.75L1151.359375,242.75L1249.6894988451013,242.75Q1263.046875,242.75 1275.3888418327206,237.641638966999L1287.7308086654411,232.53327793399802"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_START_InputParserNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span || (_span = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.78125, 30.5)",
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.1328125, -10.5)",
    "data-id": "L_InputParserNode_ToolExecutorNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 62.265625
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span2 || (_span2 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "route: tool"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.78125, 166.5)",
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.75, -10.5)",
    "data-id": "L_InputParserNode_AggregateNutritionNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 89.5
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span3 || (_span3 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "route: nutrition"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.78125, 261.5)",
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.578125, -10.5)",
    "data-id": "L_InputParserNode_ReviewDashboardNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 87.15625
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span4 || (_span4 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "route: reviews"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.78125, 356.5)",
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.359375, -10.5)",
    "data-id": "L_InputParserNode_ProcessCustomizationNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 102.71875
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span5 || (_span5 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "route: customize"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.515625, 98.5)",
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.8046875, -10.5)",
    "data-id": "L_InputParserNode_ResponseFormatterNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 99.609375
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span6 || (_span6 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "route: chat/error"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_AggregateNutritionNode_ResponseFormatterNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span7 || (_span7 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_ReviewDashboardNode_ResponseFormatterNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span8 || (_span8 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_ProcessCustomizationNode_ResponseFormatterNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span9 || (_span9 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1007.375, 185.25)",
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.296875, -10.5)",
    "data-id": "L_ResponseFormatterNode_VisualizeNutritionNode_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 64.59375
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span10 || (_span10 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "if visualize"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_VisualizeNutritionNode_END_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span11 || (_span11 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_ResponseFormatterNode_END_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span12 || (_span12 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.7890625, 166.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "START",
    id: "flowchart-START-0",
    className: "node default"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 0,
    cx: 0,
    r: 46.7890625,
    style: {
      fill: "#00C853 !important",
      stroke: "#FFFFFF !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.7890625, -10.5)",
    style: {
      color: "#FFFFFF !important"
    },
    className: "label"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 29.578125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(255, 255, 255) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#FFFFFF !important"
    }
  }, _p || (_p = /*#__PURE__*/React.createElement("p", null, "Start"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.5, 166.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "InputParserNode",
    id: "flowchart-InputParserNode-1",
    className: "node default"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "#FFFFFF !important",
      fill: "#E1BEE7 !important"
    },
    transform: "translate(-84.921875,45.5)",
    className: "label-container",
    points: "26,0 143.84375,0 169.84375,-45.5 143.84375,-91 26,-91 0,-45.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.921875, -10.5)",
    style: {
      color: "#000000 !important"
    },
    className: "label"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 105.84375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(0, 0, 0) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#000000 !important"
    }
  }, _p2 || (_p2 = /*#__PURE__*/React.createElement("p", null, "InputParserNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.515625, 30.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "ToolExecutorNode",
    id: "flowchart-ToolExecutorNode-3",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 146.40625,
    y: -22.5,
    x: -73.203125,
    "data-id": "ToolExecutorNode",
    style: {
      stroke: "#FFFFFF !important",
      fill: "#FF6D00 !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.203125, -10.5)",
    style: {
      color: "#FFFFFF !important"
    },
    className: "label"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 114.40625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(255, 255, 255) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#FFFFFF !important"
    }
  }, _p3 || (_p3 = /*#__PURE__*/React.createElement("p", null, "ToolExecutorNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.515625, 166.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "AggregateNutritionNode",
    id: "flowchart-AggregateNutritionNode-5",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 182.21875,
    y: -22.5,
    x: -91.109375,
    "data-id": "AggregateNutritionNode",
    style: {
      stroke: "#FFFFFF !important",
      fill: "#FFF9C4 !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75.109375, -10.5)",
    style: {
      color: "#000000 !important"
    },
    className: "label"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 150.21875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(0, 0, 0) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#000000 !important"
    }
  }, _p4 || (_p4 = /*#__PURE__*/React.createElement("p", null, "AggregateNutritionNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.515625, 261.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "ReviewDashboardNode",
    id: "flowchart-ReviewDashboardNode-7",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 179.875,
    y: -22.5,
    x: -89.9375,
    "data-id": "ReviewDashboardNode",
    style: {
      stroke: "#FFFFFF !important",
      fill: "#BBDEFB !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-73.9375, -10.5)",
    style: {
      color: "#000000 !important"
    },
    className: "label"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 147.875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(0, 0, 0) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#000000 !important"
    }
  }, _p5 || (_p5 = /*#__PURE__*/React.createElement("p", null, "ReviewDashboardNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.515625, 356.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "ProcessCustomizationNode",
    id: "flowchart-ProcessCustomizationNode-9",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 204.75,
    y: -22.5,
    x: -102.375,
    "data-id": "ProcessCustomizationNode",
    style: {
      stroke: "#FFFFFF !important",
      fill: "#C8E6C9 !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86.375, -10.5)",
    style: {
      color: "#000000 !important"
    },
    className: "label"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 172.75
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(0, 0, 0) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#000000 !important"
    }
  }, _p6 || (_p6 = /*#__PURE__*/React.createElement("p", null, "ProcessCustomizationNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(839.484375, 214)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "ResponseFormatterNode",
    id: "flowchart-ResponseFormatterNode-11",
    className: "node default"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "#FFFFFF !important",
      fill: "#E1BEE7 !important"
    },
    transform: "translate(-110.59375,45.5)",
    className: "label-container",
    points: "26,0 195.1875,0 221.1875,-45.5 195.1875,-91 26,-91 0,-45.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78.59375, -10.5)",
    style: {
      color: "#000000 !important"
    },
    className: "label"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 157.1875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(0, 0, 0) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#000000 !important"
    }
  }, _p7 || (_p7 = /*#__PURE__*/React.createElement("p", null, "ResponseFormatterNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1151.359375, 185.25)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "VisualizeNutritionNode",
    id: "flowchart-VisualizeNutritionNode-19",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 173.375,
    y: -22.5,
    x: -86.6875,
    "data-id": "VisualizeNutritionNode",
    style: {
      stroke: "#FFFFFF !important",
      fill: "#FFCDD2 !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.6875, -10.5)",
    style: {
      color: "#000000 !important"
    },
    className: "label"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 141.375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(0, 0, 0) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#000000 !important"
    }
  }, _p8 || (_p8 = /*#__PURE__*/React.createElement("p", null, "VisualizeNutritionNode"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1332.5078125, 214)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "END",
    id: "flowchart-END-21",
    className: "node default"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 0,
    cx: 0,
    r: 44.4609375,
    style: {
      stroke: "#FFFFFF !important",
      fill: "#2962FF !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.4609375, -10.5)",
    style: {
      color: "#FFFFFF !important"
    },
    className: "label"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 24.921875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      color: "rgb(255, 255, 255) !important",
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      color: "#FFFFFF !important"
    }
  }, _p9 || (_p9 = /*#__PURE__*/React.createElement("p", null, "End")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "130%",
    height: "130%",
    id: "drop-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 4,
    dx: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "150%",
    height: "150%",
    id: "drop-shadow-small"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 2,
    dx: 2
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    y2: "0%",
    x2: "100%",
    y1: "0%",
    x1: "0%",
    gradientUnits: "objectBoundingBox",
    id: "export-svg-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#cccccc",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "hsl(180, 0%, 18.3529411765%)",
    offset: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase8LangraphFlow);
export default __webpack_public_path__ + "static/media/phase8_langraph_flow.8e8d7c63e3499e0dfd82eb0e85071e6e.svg";
export { ForwardRef as ReactComponent };